@if (item) {
  <div class="stage-card">
    @if (item && currentPlatform) {
      <img
        class="stage-card__image"
        (click)="openLink()"
        [class.stage-card__image--centered]="isImageCentered"
        [src]="
          item.uploadedFile
            ? (item.name | getFilePicture: currentPlatform !== Platform.desktop)
            : 'assets/images/icons-svg/files/mp4.svg'
        "
      />
      <div class="stage-card__content">
        <app-text
          [text]="item.name"
          [textType]="TextType.base"
          [textSize]="TextSizes.h4Name"
          class="nav-link"
          (click)="openLink()"
        ></app-text>
        @if (subtext) {
          <app-text
            class="stage-card__note"
            [text]="subtext"
            [textType]="TextType.base"
            [textSize]="TextSizes.h5Post"
          ></app-text>
        }
      </div>
    }
  </div>

  <ion-modal cssClass="stage-card__video-modal" [isOpen]="isVideoModalOpen" (didDismiss)="closeVideoModal()">
    <ng-template>
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <div class="stage-card__modal-header">
            <img
              src="/assets/images/icons-svg/arrow-right.svg"
              class="stage-card__modal-close"
              (click)="closeVideoModal()"
              alt="Закрыть"
            />
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-content scroll-y="false" [forceOverscroll]="false">
        @if (embedVideoUrl) {
          <iframe [src]="embedVideoUrl"></iframe>
        } @else if (directVideoUrl) {
          <video controls playsinline [src]="directVideoUrl"></video>
        }
      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal
    cssClass="modal-pdf-fullscreen"
    [isOpen]="isPdfModalOpen"
    (didDismiss)="closePdfModal()"
  >
    <ng-template>
      @if (pdfUrl) {
        <app-pdf-viewer-modal [url]="pdfUrl" (closed)="closePdfModal()"></app-pdf-viewer-modal>
      }
    </ng-template>
  </ion-modal>
}
